import React, { memo } from 'react';
import CommonInput from '../../../../components/Dashboard-res/CommonComponent/CommonInput';

import { useFormikContext } from 'formik';

const DeveloperDetails = () => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    validateForm
  } = useFormikContext();

  return (
    <>
      <h2 className="font-roboto font-medium text-sm text-black-400 mt-3">
        Developer Details
      </h2>
      <div className="flex flex-col xl:flex-row justify-between flex-wrap mt-2 ">
        <div className="w-full xl:w-9/20">
          <CommonInput
            name="developerName"
            onChange={e => {
              handleChange(e);
              setFieldValue('developerName', e.target.value);
            }}
            onBlur={e => {
              handleBlur(e);
            }}
            value={values.developerName}
            stylesContainer={{
              height: '52px',
              maxWidth: '100%',
              marginBottom: '40px'
            }}
            legendName="Developer Name"
            error={touched.developerName && errors.developerName}
            errorMsg={errors.developerName}
            touched={touched.developerNamenyName}
          />
        </div>
        <div className="w-full xl:w-9/20">
          <CommonInput
            name="projName"
            onChange={e => {
              handleChange(e);
              setFieldValue('projName', e.target.value);
            }}
            onBlur={e => {
              handleBlur(e);
            }}
            value={values.projName}
            stylesContainer={{
              height: '52px',
              maxWidth: '100%',
              marginBottom: '40px'
            }}
            legendName="Project Name"
            error={touched.projName && errors.projName}
            errorMsg={errors.projName}
            touched={touched.projName}
          />
        </div>
        <div className="w-full xl:w-9/20">
          <CommonInput
            name="reraNo"
            onChange={e => {
              handleChange(e);
              setFieldValue('reraNo', e.target.value);
            }}
            onBlur={e => {
              handleBlur(e);
            }}
            value={values.reraNo}
            stylesContainer={{
              height: '52px',
              maxWidth: '100%',
              marginBottom: '40px'
            }}
            legendName="RERA No"
            error={touched.reraNo && errors.reraNo}
            errorMsg={errors.reraNo}
            touched={touched.reraNo}
          />
        </div>

      </div>
    </>
  );
};

export default memo(DeveloperDetails);
